import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { isEmpty, startCase } from "lodash";
import { isMobile } from "react-device-detect";
import { AnimatePresence, motion } from "framer-motion";
import OutsideClickHandler from "react-outside-click-handler";

const toastStyles = {
  error: {
    container: "s-bg-error-light dark:s-bg-error-dark",
    icon: "s-icon-notice",
    title: "Bet Error",
  },
  warning: {
    container: "s-bg-warning-light dark:s-bg-warning-dark",
    icon: "s-icon-notifications",
    title: "Warning",
  },
  success: {
    container: "s-bg-success-light dark:s-bg-success-dark",
    icon: "s-icon-check-circle",
    title: "Success",
  },
  info: {
    container: "s-bg-info-light dark:s-bg-info-dark",
    icon: "s-icon-info",
    title: "Info",
  },
};
const toastVariants = {
  hidden: { y: 100 },
  visible: {
    y: 0,
    transition: { type: "spring", stiffness: 100, duration: 0.5 },
  },
  exit: {
    y: 200,
    transition: { duration: 0.5, ease: "easeInOut" },
  },
};
const CustomToast = ({ type = "error", title, message, onClose, playType }) => {
  const {
    container,
    icon,
    title: defaultTitle,
  } = toastStyles[type] || toastStyles.error;
  const [show, setShow] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, 4000);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);
  const handleClose = () => {
    setShow(false); // trigger exit animation
  };
  return (
    <AnimatePresence
      mode="wait"
      onExitComplete={() => {
        onClose();
      }}
    >
      <motion.div
        key="overlay"
        className="s-toast-overlay s-fixed s-top-0 s-left-0 s-w-full s-h-full"
        style={{ zIndex: 70 }}
        data-testid="toast-overlay"
        onClick={handleClose}
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.3 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      />

      {isMobile ? (
        <motion.div
          key="toast"
          className="s-toast-container s-bottom-20px s-flex s-flex-col s-justify-center s-w-full s-space-y-2.5 s-fixed"
          style={{ zIndex: 80 }}
          variants={toastVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <div>
            <div
              className={`s-container s-w-335px s-text-center s-flex s-justify-center s-p-3px s-rounded-5px s-mx-auto ${container}`}
              data-testid="toast-container"
            >
              <div className="s-w-full">
                <div className="s-flex s-justify-start s-items-center s-text-global-font-on-dark s-font-bold s-py-10px s-px-9px s-text-14px relative">
                  <i
                    className={`s-text-global-font-on-dark s-text-16px ${icon}`}
                    data-testid="toast-icon-title"
                  />
                  <h4
                    className="s-ml-1 s-text-13px s-leading-none"
                    data-testid="toast-title"
                  >
                    {title || defaultTitle}
                  </h4>
                  <div
                    onClick={onClose}
                    className="s-right-32px s-icon-close s-absolute s-text-14px cursor-pointer"
                    data-testid="toast-btn-close-toast"
                  />
                </div>

                {type == "success" ? (
                  <div className="s-rounded-3px s-flex s-justify-start s-items-center s-bg-white dark:s-bg-black-800 s-min-h-40px s-p-2 s-text-global-font-default-light dark:s-text-global-font-default-dark s-leading-tight">
                    <span className="s-flex s-items-center">
                      {!isEmpty(playType) && (
                        <span
                          className="s-w-45px s-h-26px s-flex s-items-center s-justify-center s-shrink-0 s-rounded-3px s-mr-1 s-text-15px s-font-bold s-not-italic s-text-black-900 s-bg-back-200 dark:s-bg-back-500"
                          data-testid="toast-side-type"
                        >
                          {startCase(playType)}
                        </span>
                      )}
                      <span
                        className="s-flex s-items-center s-px-1 s-border-solid s-whitespace-pre-wrap s-break-all s-text-13px s-leading-120 s-text-left"
                        data-testid="toast-name"
                      >
                        {message}
                      </span>
                    </span>
                  </div>
                ) : (
                  <div
                    className="s-px-9px s-py-4 s-rounded-3px s-text-13px s-leading-120 s-text-left s-bg-white s-text-global-font-default-light dark:s-bg-black-800 dark:s-text-global-font-default-dark"
                    data-testid="toast-content"
                  >
                    {message}
                  </div>
                )}
              </div>
            </div>
          </div>
        </motion.div>
      ) : (
        <div
          className="s-toast-container s-bottom-20px s-flex s-flex-col s-justify-center s-w-full s-space-y-2.5 s-sticky"
          currencyalias="INR"
          data-v-a28287f9=""
          data-v-e7b2cd7c=""
          style={{
            "--01ebd192": "300",
            "--6db834f8": "300",
            zIndex: "300",
          }}
        >
          <div data-v-a28287f9="">
            <div
              className="s-container s-w-335px s-text-center s-flex s-justify-center s-p-3px s-rounded-5px s-mx-auto s-bg-warning-light dark:s-bg-warning-dark"
              data-testid="toast-container"
              data-v-a28287f9=""
            >
              <div className="s-w-full">
                <div className="s-flex s-justify-start s-items-center s-text-global-font-on-dark s-font-bold s-py-10px s-px-9px s-text-14px">
                  <i
                    className={`s-text-global-font-on-dark s-text-16px ${icon}`}
                    data-testid="toast-icon-title"
                  />
                  <h4
                    className="s-ml-1 s-text-13px s-leading-none"
                    data-testid="toast-title"
                  >
                    {title || defaultTitle}
                  </h4>
                  <div
                    onClick={onClose}
                    className="s-right-32px s-icon-close s-absolute s-text-14px"
                    data-testid="toast-btn-close-toast"
                  />
                </div>
                {/* <div
                  className="s-px-9px s-py-4 s-rounded-3px s-text-13px s-leading-120 s-text-left s-bg-white s-text-global-font-default-light dark:s-bg-black-800 dark:s-text-global-font-default-dark"
                  data-testid="toast-content"
                >
                  Please Login To Place Your Bet.
                </div> */}
                {type == "success" ? (
                  <div className="s-rounded-3px s-flex s-justify-start s-items-center s-bg-white dark:s-bg-black-800 s-min-h-40px s-p-2 s-text-global-font-default-light dark:s-text-global-font-default-dark s-leading-tight">
                    <span className="s-flex s-items-center">
                      {!isEmpty(playType) && (
                        <span
                          className="s-w-45px s-h-26px s-flex s-items-center s-justify-center s-shrink-0 s-rounded-3px s-mr-1 s-text-15px s-font-bold s-not-italic s-text-black-900 s-bg-back-200 dark:s-bg-back-500"
                          data-testid="toast-side-type"
                        >
                          {startCase(playType)}
                        </span>
                      )}
                      <span
                        className="s-flex s-items-center s-px-1 s-border-solid s-whitespace-pre-wrap s-break-all s-text-13px s-leading-120 s-text-left"
                        data-testid="toast-name"
                      >
                        {message}
                      </span>
                    </span>
                  </div>
                ) : (
                  <div
                    className="s-px-9px s-py-4 s-rounded-3px s-text-13px s-leading-120 s-text-left s-bg-white s-text-global-font-default-light dark:s-bg-black-800 dark:s-text-global-font-default-dark"
                    data-testid="toast-content"
                  >
                    {message}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </AnimatePresence>
  );
};

// Default Props
CustomToast.propTypes = {
  type: PropTypes.oneOf(["error", "warning", "success", "info"]),
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  playType: PropTypes.string,
};

export default CustomToast;
